/* eslint-disable no-magic-numbers */
export default function when(
	condition,
	{
		interval = 500,
		timeout = 5000,
	} = {}
) {
	const startedAt = Date.now();
	const rejectAt = startedAt + timeout;
	return new Promise( ( resolve, reject ) => {
		let handle = setTimeout( function tryCondition() {
			clearTimeout( handle );
			handle = null;
			const isSuccessful = !!condition();
			if ( isSuccessful ) {
				return resolve();
			}
			const now = Date.now();
			if ( now >= rejectAt ) {
				const e = new Error( "when timeout exceeded" );
				e.startedAt = startedAt;
				e.rejectAt = rejectAt;
				e.rejectedAt = now;
				e.interval = interval;
				e.timeout = timeout;
				return reject( e );
			}
			handle = setTimeout( tryCondition, interval );
		}, interval );
	} );
}
